// 3rd party
import * as React from 'react';
import { observer } from 'mobx-react';

// Shared UI
import { useLocalization } from '@shared-ui/localization-context';

// UI Toolkit
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkText } from 'uitk-react-text';

// Hooks
import { useStores } from 'hooks';

// Models
import { Product, Program } from 'models';

interface ExpediaPackageProps {
  program?: Program;
  product?: Product;
  userProgram?: any;
}

const ExpediaPackage = observer(
  // tslint:disable-next-line:no-shadowed-variable
  function ExpediaPackage({ program, product, userProgram }: ExpediaPackageProps): JSX.Element {
    const l10n = useLocalization();
    const { analytics } = useStores();

    return (
      <main className="container">
        <UitkLayoutGrid columns={{ large: 2 }} space="twelve">
          <UitkLayoutGridItem colSpan={2}>
            <div>
              <section>
                <p>
                  <UitkText inline={true} size={500}>
                    {
                      'Help your visitors find great package deals. When travelers book a flight and hotel together, they can enjoy big savings like 100% off their flight or hotel. Choose a destination that matches your content and let the widget do the rest.'
                    }
                  </UitkText>
                </p>
              </section>
            </div>
          </UitkLayoutGridItem>

          <UitkLayoutGridItem>
            <div>
              <section>{/* TODO: Add Product Configuration content */}</section>
            </div>
          </UitkLayoutGridItem>

          <UitkLayoutGridItem>
            <div>
              <UitkLayoutGrid space="twelve">
                <UitkLayoutGridItem>
                  <div>
                    <section>{/* TODO: Add Product Preview content */}</section>
                  </div>
                </UitkLayoutGridItem>

                <UitkLayoutGridItem>
                  <div>
                    <section>{/* TODO: Add Product Code content */}</section>
                  </div>
                </UitkLayoutGridItem>
              </UitkLayoutGrid>
            </div>
          </UitkLayoutGridItem>
        </UitkLayoutGrid>
      </main>
    );
  },
);

export { ExpediaPackage };
